export const allUsersHandlerAction = users => ({
  type: "UPDATE_ALL_USERS",
  payload: users
});

export const allAppicationsHandlerAction = applications => ({
  type: "UPDATE_ALL_APPLICATIONS",
  payload: applications
});
